export default __webpack_public_path__ + "static/media/section22.7e79b63d.svg";